module.exports = __webpack_public_path__ + "img/dep_tobacco@3x.55a959a5.png";